export enum GaugeColor {
	Red,
	Green,
}
